<template>
    <CustomDialog :value="show" :defaultTitle="$t('marketing.abandoned_cart.preview_title')">
        <template #content>
            <div class="preview-content ppv2-p-4 ppv2-bg-gray-50 ppv2-rounded-xl">
                <!-- Subject Preview -->
                <div class="ppv2-mb-6 ppv2-pb-4 ppv2-border-b ppv2-border-gray-200">
                    <p class="ppv2-text-sm ppv2-text-gray-500 ppv2-mb-1">
                        {{ $t('marketing.abandoned_cart.subject_label') || 'Objet :' }}
                    </p>
                    <p class="poppinsSemiBold ppv2-text-black ppv2-text-lg">{{ processedSubject }}</p>
                </div>

                <!-- Email Body Preview -->
                <div class="email-body ppv2-bg-white ppv2-p-8 ppv2-rounded-lg ppv2-shadow-sm ppv2-min-h-[400px]">
                    <div class="ppv2-prose ppv2-max-w-none" v-html="processedMessage"></div>
                </div>
            </div>
        </template>
        <template #actions>
            <BaseButton variant="primary" @click="$emit('close')">
                {{ $t('common.close') || 'Fermer' }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
import CustomDialog from '../../../Shared/CustomDialog.vue'
import BaseButton from '../../../Shared/BaseButton.vue'

export default {
    name: 'AbandonedCartPreviewModal',
    components: {
        CustomDialog,
        BaseButton,
    },
    props: {
        show: Boolean,
        emailData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            // Les alias anglais sont proposés au même titre que les français dans la liste des
            // variables ({{Prénom}} / {{firstname}}) et l'email les substitue tous les deux :
            // les omettre ici faisait passer pour cassées, dans l'aperçu, des variables
            // parfaitement fonctionnelles.
            defaultValues: {
                '{{Prénom}}': 'Jean',
                '{{firstname}}': 'Jean',
                '{{Nom}}': 'Dupont',
                '{{lastname}}': 'Dupont',
                '{{Date de réservation}}': '25/06/2026',
                '{{booking_date}}': '25/06/2026',
                '{{Heure de réservation}}': '14:00',
                '{{booking_time}}': '14:00',
                '{{Établissement}}': 'PlayPro Arena',
                '{{establishment}}': 'PlayPro Arena',
            },
        }
    },
    computed: {
        processedSubject() {
            let subject = this.emailData.subject || "Pas d'objet"
            Object.keys(this.defaultValues).forEach((tag) => {
                subject = subject.replace(new RegExp(tag, 'g'), this.defaultValues[tag])
            })
            return subject
        },
        processedMessage() {
            let message = this.emailData.message || ''

            // Replace standard variables
            Object.keys(this.defaultValues).forEach((tag) => {
                message = message.replace(new RegExp(tag, 'g'), this.defaultValues[tag])
            })

            // Les anciens jetons « bouton de réservation » ne sont plus proposés par l'écran BO :
            // un message enregistré avant leur retrait ne doit pas les afficher en clair.
            message = message.replace(/{{Bouton de réservation}}/g, '').replace(/{{reservation_button}}/g, '')

            // Convert newlines to breaks if not already HTML
            if (!/<[a-z][\s\S]*>/i.test(message)) {
                message = message.replace(/\n/g, '<br>')
            }

            return message
        },
    },
}
</script>

<style scoped>
.preview-content {
    max-height: 70vh;
    overflow-y: auto;
}
</style>
